import { render, staticRenderFns } from "./videoSecurity.vue?vue&type=template&id=c0c8ea26&scoped=true&"
import script from "./videoSecurity.vue?vue&type=script&lang=js&"
export * from "./videoSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c8ea26",
  null
  
)

export default component.exports